// import LocomotiveScroll from "locomotive-scroll";
import { gsap } from "gsap";
import Lenis from "lenis";
import AOS from "aos";
import "../../../node_modules/aos/dist/aos.css"; // Import AOS styles
import Rellax from "rellax";

// Initialize Lenis
const lenis = new Lenis({
	autoRaf: true,
});

// Declare rellax in module scope so it's accessible to event listeners
let rellax;

export const initScroll = () => {
	AOS.init();
	// Initialize Rellax with responsive options and only run when in viewport

	rellax = new Rellax(".rellax", {
		center: true,
		callback: function (positions) {
			// positions is an array containing all the positions of elements
			// Each position contains: top, bottom, height, speed, percentage
		},
	});
	setTimeout(() => {
		// give it a refresh after a short delay in case DOM elements shift
		if (rellax && typeof rellax.refresh === 'function') {
			rellax.refresh();
		}
	}, 1000);

	lenis.on("scroll", (e) => {
		// applyScrollAnimations(e.scroll);
	});

	// Refresh Rellax positions on window resize
	window.addEventListener("resize", () => {
		if (rellax && typeof rellax.refresh === 'function') {
			rellax.refresh();
		}
	});
};

// Scroll to top of facet template when paginating through trips // using facets in general
(function($) {
	$(document).on('facetwp-loaded', function() {
		if ( FWP.loaded ) { 
			$('html, body').animate({
			scrollTop: $('.facetwp-template').offset().top
			}, 150);
		}
	});
})(jQuery);